import React from 'react';
import dynamic from 'next/dynamic';

import { renderers } from '../../../content/renderers';
import { ContentBlockRenderer } from '../../../types/Block';
import { SerializableBlock } from '../../../types/SerializableBlock';
import { PreviewBlockErrorProps } from '../PreviewErrorOverlay';
import * as styles from './ContentBlocks.styles';

const PreviewBlockError = dynamic<PreviewBlockErrorProps>(() =>
  import('../PreviewErrorOverlay').then((mod) => mod.PreviewBlockError),
);

interface ContentBlocksProps {
  blocks: SerializableBlock[];
  isPreview: boolean;
}

export const ContentBlocks = ({ blocks, isPreview }: ContentBlocksProps) => (
  <>
    {blocks.map((block) => {
      const { blockName, errors = [], serializedData, type, uid } = block;

      const { Component, ...renderer } = renderers[type] as unknown as ContentBlockRenderer;
      const props = renderer.getProps?.(serializedData) ?? serializedData;

      const showComponent = isPreview || !errors.some((error) => error.preventRender);
      const showPreviewErrors = isPreview && errors.length > 0;

      return (
        <div key={uid} css={styles.blockContainer}>
          {showComponent && <Component {...props} />}
          {showPreviewErrors && <PreviewBlockError title={blockName} errors={errors} />}
        </div>
      );
    })}
  </>
);
